export function UnifiedDiffTable(
  props: React.PropsWithChildren<{
    lineWidth: string
    showLeftLineNumbers?: boolean
    showRightLineNumbers?: boolean
  }>,
) {
  const showLeftLineNumbers = props.showLeftLineNumbers ?? true
  const showRightLineNumbers = props.showRightLineNumbers ?? true

  return (
    <>
      <thead className="sr-only">
        <tr>
          {showLeftLineNumbers && <th scope="col">Original file line number</th>}
          {showRightLineNumbers && <th scope="col">Diff line number</th>}
          <th scope="col">Diff line change</th>
        </tr>
      </thead>
      <colgroup>
        {showLeftLineNumbers && <col width={props.lineWidth} />}
        {showRightLineNumbers && <col width={props.lineWidth} />}
        <col width="100%" />
      </colgroup>
      <tbody>{props.children}</tbody>
    </>
  )
}
